/**
 * @public
 */
export enum RoleCapacity {
  apiUsersClientProfileRead = 'api.users.client.profile.read',
  apiUsersClientProfileWrite = 'api.users.client.profile.write',
  apiUsersClientGrantsRead = 'api.users.client.grants.read',
  apiUsersClientGrantsWrite = 'api.users.client.grants.write',
  apiInvoiceOperateEngie = 'api.invoices.invoice.operate.engie',
  apiInvoiceRead = 'api.invoices.invoice.read',
  apiInvoicesDataRead = 'api.invoices.data.read',
  apiForecastClientRead = 'api.forecasts.client.read',
  apiForecastOpenRead = 'api.forecasts.open.read',
  apiForecastClientWrite = 'api.forecasts.client.write',
  apiForecastOpenWrite = 'api.forecasts.open.write',
  apiForecastClosedWrite = 'api.forecasts.closed.write',
  apiTransactionOperateClient = 'api.contracts.transactions.operate.client',
  apiTransactionOperateEngie = 'api.contracts.transactions.operate.engie',
  apiContractBasicRead = 'api.contracts.basic.read',
  apiContractHeaderBasicRead = 'api.contracts.headers.read',
  apiContractFullRead = 'api.contracts.full.read',
  apiContractFullWrite = 'api.contracts.full.write',
  apiContractPaymentSettingsWrite = 'api.contracts.payment_settings.write',
  apiContractsNominationsOperateClient = 'api.contracts.nominations.operate.client',
  apiContractsNominationsReadClient = 'api.contracts.nominations.read.client',
  apiContractsClientDealsRead = 'api.contracts.client_deals.read',
  apiPortalDocumentsRead = 'api.portal.documents.read',
  apiPortalDocumentsWrite = 'api.portal.documents.write',
  apiReferentialRead = 'api.referential.read',
  apiVolumesMeteringRead = 'api.volumes.metering.read',
  apiVolumesNetworkRead = 'api.volumes.network.read',
  apiVolumesProfileRead = 'api.volumes.profile.read',
  apiVolumesSubscriptionRead = 'api.volumes.subscription.read',
  apiCarbonDocumentsRead = 'api.carbon.documents.read',
  apiCarbonReportingRead = 'api.carbon.reporting.read',
  apiMidbackBiddingsOperateClient = 'api.midback.biddings.operate.client',
  apiMidbackBiddingsRead = 'api.midback.biddings.read',
  //only for test
  apiCapacityNotExist = 'api.capacity.not.exist',
}
